/**
 * installer for fomods packaged inside another archive.
 * All this does is request the nested file, then delegate the installation
 * to another installer.
 */
import PromiseBB from "bluebird";
import * as path from "path";
import { log } from "../../util/log";
function testSupported(files) {
    return new PromiseBB((resolve, reject) => {
        const fomod = files.find((file) => path.extname(file) === ".fomod");
        if (fomod !== undefined) {
            resolve({ supported: true, requiredFiles: [fomod] });
        }
        else {
            resolve({ supported: false, requiredFiles: [] });
        }
    });
}
function install(api, files, destinationPath, gameId, choicesIn, unattended, progress) {
    return new PromiseBB((resolve, reject) => {
        const fomod = files.find((file) => path.extname(file) === ".fomod");
        const filePath = path.join(destinationPath, fomod);
        log("debug", "install nested", filePath);
        resolve({
            instructions: [
                {
                    type: "submodule",
                    key: fomod,
                    path: filePath,
                    choices: choicesIn,
                    unattended,
                },
            ],
        });
    });
}
function init(context) {
    context.registerInstaller("nested_fomod", 0, testSupported, (files, destinationPath, gameId, progress, choicesIn, unattended) => install(context.api, files, destinationPath, gameId, choicesIn, unattended, progress));
    return true;
}
export default init;
